export default {
	wird: "Wird",
	contests: "Contests",
	wirdLogo: "Wird Logo",
	welcome: "Welcome to Wird Contests!",
	siteDescription:
		"Wird is a non-profitable platform wich will assist teachers in creating personalized contests for their students.",
	getStarted: "Get started",
	ourService: "Our service",
	contactUs: "Contact us",
	adminPanel: "Admin panel",
	introTitle: "Introducing Wird",
	introText: "Learn about our project through this video.",
	ServiceSection: {
		title: "Our service",
		description:
			"Wird platform provides many of options that helps guardians, teacher, and students to improve their Ramadan performance.",
		admin: {
			title: "Website as Admin Panal",
			description:
				"A website for parents and teachers, where they customize their contest, and monitor individuals and groups achievements. Supervisors can use the website to:",
			items: [
				"Create and adjust their contest standards.",
				"Monitor the activities of students and kids through diagrams and tables.",
				"Split students into groups and assign a supervisor for each group.",
				"Create advertisments on a public or a private level.",
			],
		},
		participant: {
			title: "An Application for Students",
			description:
				"An application for our kids and students to register their daily activity and compete with others. Students can use the application to:",
			items: [
				"Recording daily devotional data.",
				"Follow-up on the students own performance through graphs and daily performance tables.",
				"Compete with other contest participants.",
			],
		},
	},
	GetStartedSection: {
		title: "Get Started",
		description:
			"Take the first step towards motivating your students with our online personalized contests with on Wird.",
		iAmCreator: "I'm a Creator",
		forParentsAndTeachers: "For parents and teachers",
		iAmParticipant: "I'm a Participant",
		forStudentsAndKids: "For students and kids",
		downloadNow: "Download Now",
		asStudentDownloadApp:
			"As a student you can Download Wird application and enroll to your contest easily.",
		getOnGooglePlay: "Get on Google Play",
		downloadOnAppStore: "Download on App Store",
		downloadOnAppGallery: "Download on AppGallery",
		startContest: "Create your competition",
		asTeacherSignUp:
			"As a teacher you can Sign Up and start your contest for your students with Wird. On the Admin Panel you will have control of your contest easily.",
		login: "Login",
		signup: "Sign Up",
		comingSoon: "Coming Soon",
		comingSoonOnIOS: "Coming Soon on iOS",
	},
	ContactUsSection: {
		title: "Contact Us",
		description: "To start a contest for your organization, your team, or your family.",
		volunteer: "Volunteer with us",
		inquiries: "Contact and Inquiries",
		followUs: "Follow us",
		telegram: "Telegram Channel",
	},
	allRightsReserved: "All rights reserved © {{year}} Wird",
	links: "Links",
	getStudentsApp: "Get Students App",
	EmailConfirmPage: {
		loading: "Confirming your email...",
		confirmed: "Email Confirmed",
		confirmedMessage: "Your email has been confirmed. You can now login.",
		invalidLink: "Invalid Confirmation Link",
		invalidLinkMessage: "The confirmation link is invalid or expired. Please try again.",
	},
	ResetPasswordPage: {
		title: "Reset Password",
		invalidLink: "Invalid Link",
		invalidLinkMessage: "The password reset link is invalid. Please try again.",
		success: "Your password has been reset",
		successMessage: "You can now login with your new password.",
		resetPassword: "Reset Password",
		newPassword: "New Password",
		confirmNewPassword: "Confirm New Password",
		enterNewPassword: "Enter your new password",
	},
	ForgotPasswordPage: {
		title: "Forgot Password",
		emailSent: "Password Reset Email Sent",
		emailSentMessage: "Check your email for further instructions.",
		forgotPassword: "Forgot Password",
		forgotPasswordFormMessage: "Enter your username to reset your password.",
		username: "Username",
		email: "Email",
		sendResetLink: "Send Reset Link",
		forgotUsername: "Forgot Username?",
	},
	ForgotUsernamePage: {
		title: "Forgot Username",
		forgotUsername: "Forgot Username",
		forgotUsernameFormMessage: "Enter your email to recover your username.",
		emailSent: "Username Recovery Email Sent",
		emailSentMessage: "Check your email for further instructions.",
		email: "Email",
		sendUsername: "Send Username",
		forgotPassword: "Forgot Password?",
	},
	soon: "Soon",
	wirdStats: {
		title: "Wird Stats",
		registeredMembers: "Registered Members",
		createdContests: "Created Contests",
		submissions: "Submissions for last 7 days",
		contestsPerCountry: "Contests per Country",
		contestsCount_one: "...and <strong>one</strong> contest",
		contestsCount_other: "...and <strong>{{count}}</strong> contests",
		inCountries_one: "in <strong>one</strong> other country",
		inCountries_other: "in <strong>{{count}}</strong> other countries",
	},
	policy: "Our Policy",
	help: "Help",
	adminPanelHelp: "Admin Panel Help",
	adminPanelHelpText: "Learn how to use the admin panel through this playlist.",
} as const;
